export default function ($http) {
    return function (vrm) {
        return $http.get(`api/vehicles/vrm/${ vrm }`)
            .then(resp => resp.data.result);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/vehicles/getVehicleDetails.js